{
  "name": "msbc-converter",
  "private": true,
  "version": "0.15.10",
  "type": "module",
  "scripts": {
    "dev": "NODE_ENV=development VITE_DEPRECATION_TRACE=1 nodemon --exitcrash --trace-warnings --watch src --ext ts --exec tsx src/server/main.ts",
    "dev:debug": "NODE_ENV=development NODE_OPTIONS=--inspect=0.0.0.0:9229 nodemon --exitcrash --trace-warnings --watch src --ext ts --exec tsx src/server/main.ts",
    "build": "rimraf dist && vite build",
    "1start": "tsx --enable-source-maps src/server/main.ts",
    "start": "node --import tsx/esm -r tsconfig-paths/register src/server/main.ts",
    "test": "jest",
    "test:watch": "jest --watchAll",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:all": "jest && playwright test"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.30.0",
    "@preact/signals-react": "^3.10.0",
    "@types/express-session": "^1.19.0",
    "acorn": "^8.16.0",
    "acorn-typescript": "^1.4.13",
    "acorn-walk": "^8.3.5",
    "archiver": "^7.0.1",
    "axios": "^1.15.2",
    "bcrypt": "^6.0.0",
    "chokidar": "^5.0.0",
    "cors": "^2.8.6",
    "crypto-js": "^4.2.0",
    "date-fns": "^4.1.0",
    "dotenv": "^17.4.2",
    "express": "^5.2.1",
    "express-session": "^1.19.0",
    "fast-xml-parser": "^5.7.2",
    "handlebars": "^4.7.9",
    "i18next": "^26.0.8",
    "i18next-browser-languagedetector": "^8.2.1",
    "i18next-fs-backend": "^2.6.5",
    "i18next-http-backend": "^3.0.6",
    "i18next-http-middleware": "^3.9.6",
    "jsonwebtoken": "^9.0.3",
    "jszip": "^3.10.1",
    "mjml": "^5.1.0",
    "mongoose": "^9.6.1",
    "morgan": "^1.10.1",
    "multer": "2.1.1",
    "nodemailer": "^8.0.7",
    "p-queue": "^9.2.0",
    "pdfkit": "^0.18.0",
    "prettier": "^3.8.3",
    "query-string": "^9.3.1",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-dropzone": "^15.0.0",
    "react-hook-form": "^7.74.0",
    "react-hotkeys-hook": "^5.2.4",
    "react-i18next": "^17.0.6",
    "react-is": "18.3.1",
    "socket.io": "^4.8.3",
    "tsconfig-paths": "^4.2.0",
    "tsx": "^4.21.0",
    "typescript": "^6.0.3",
    "unzipper": "^0.12.3",
    "uuid": "^14.0.0",
    "vite-express": "^0.22.1",
    "winston": "^3.19.0",
    "winston-daily-rotate-file": "^5.0.0",
    "winston-mongodb": "^7.0.1",
    "winston-transport": "^4.9.0",
    "xlsx": "^0.18.5",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@fortawesome/react-fontawesome": "^3.3.1",
    "@monaco-editor/react": "^4.7.0",
    "@playwright/test": "^1.62.1",
    "@rsuite/icons": "^1.4.0",
    "@types/archiver": "^7.0.0",
    "@types/bcrypt": "^6.0.0",
    "@types/bcryptjs": "^3.0.0",
    "@types/cors": "^2.8.19",
    "@types/crypto-js": "^4.2.2",
    "@types/express": "^5.0.6",
    "@types/jest": "^30.0.0",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/mjml": "^5.0.0",
    "@types/morgan": "^1.9.10",
    "@types/multer": "^2.1.0",
    "@types/node": "^25.6.0",
    "@types/nodemailer": "^8.0.0",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@types/supertest": "^7.2.0",
    "@types/unzipper": "^0.10.11",
    "@uidotdev/usehooks": "^2.4.1",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitejs/plugin-react-oxc": "^0.4.3",
    "bcryptjs": "^3.0.3",
    "flexlayout-react": "^0.9.0",
    "jest": "^30.3.0",
    "mongodb-memory-server": "^11.1.0",
    "nodemon": "^3.1.14",
    "react-device-detect": "^2.2.3",
    "react-json-tree": "^0.20.0",
    "react-router-dom": "^7.14.2",
    "rimraf": "^6.1.3",
    "rsuite": "^6.1.3",
    "rsuite-table": "^5.19.2",
    "sass": "^1.99.0",
    "socket.io-client": "^4.8.3",
    "split-pane-react": "^0.1.3",
    "supertest": "^7.2.2",
    "ts-jest": "^29.4.9",
    "vite": "^8.0.10"
  }
}
